// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_cw","cityChooser__text":"c-j_cx","cityChooser__placeholder":"c-j_cy","cityChooser__buttonIcon":"c-j_cz"};